module.exports = __webpack_public_path__ + "assets/img/road-l.5574992.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/road-l.jpg
// module id = Ahn9
// module chunks = 0